import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/esg.jsx';
import PropTypes from 'prop-types';

export default class extends View {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            tab: 'environmental',
            showModal: false
        };

        return this;
    }

    toggleTab = tab => {
        this.setState({tab: tab});
    };

    toggleModal() {
        const willOpen = !this.state.showModal;
        this.setState({showModal: willOpen});

        document.body.classList.toggle('disable-scroll', willOpen);
    }

    navigate = (...args) => {
        return this.context.app.navigate(...args);
    };

    static displayName = 'About.Views.Esg';

    static contextTypes = {
        app: PropTypes.object
    };
}
